export const BOOTSTRAP_TIME_LOGS = 'BOOTSTRAP_TIME_LOGS'
export const ADD_TIME_LOG = 'ADD_TIME_LOG'
export const UPDATE_TIME_LOG = 'UPDATE_TIME_LOG'
export const DELETE_TIME_LOG = 'DELETE_TIME_LOG'
export const DELETE_MULTIPLE_TIME_LOGS = 'DELETE_MULTIPLE_TIME_LOGS'
export const SET_SELECTED_TIME_LOGS = 'SET_SELECTED_TIME_LOGS'
export const SET_TOTAL_TIME_LOGS = 'SET_TOTAL_TIME_LOGS'
export const SET_SELECT_ALL_STATE = 'SET_SELECT_ALL_STATE'
export const SET_SELECTED_VIEW_TIME_LOG = 'SET_SELECTED_VIEW_TIME_LOG'
